var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 12 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.125 19.1.7 10.7a.9.9 0 0 1-.212-.325A1.1 1.1 0 0 1 .425 10q0-.2.063-.375A.9.9 0 0 1 .7 9.3L9.125.875q.35-.35.875-.35t.9.375.375.875a1.2 1.2 0 0 1-.375.875L3.55 10l7.35 7.35q.35.35.35.862 0 .513-.375.888a1.2 1.2 0 0 1-.875.375 1.2 1.2 0 0 1-.875-.375"
  })));
};
export default SvgArrow;